export default function formatarNome(value: string): string {
    return value ? value.toLowerCase()
        .replace(/(?:^|\s|["'([{])+\S/g, char => char.toUpperCase()) : value;
}